// extracted by mini-css-extract-plugin
export default {"dashboardSelector":"Tabs_dashboardSelector__t+2ev"};